"use strict";

require("core-js/modules/es6.array.filter");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.object.keys");

require("core-js/modules/es6.array.map");

require("core-js/modules/es6.array.sort");

require("core-js/modules/es6.object.define-property");

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var components_1 = require("@lsg/components");

var helper_1 = require("./helper");

function createLsgSrcsetFromFluidImage(fluid) {
  if (fluid && fluid.srcSet) {
    var images = helper_1.generateSizesObjectFromSrcSet(fluid.srcSet);
    var keys = Object.keys(images).map(function (e) {
      return parseInt(e, 10);
    }).sort(function (a, b) {
      return a - b;
    });
    var last = images[keys[keys.length - 1]];
    return {
      "default": images[keys.filter(function (el) {
        return el >= 640;
      })[0]] || last,
      xs: images[keys.filter(function (el) {
        return el >= 640;
      })[0]] || last,
      sm: images[keys.filter(function (el) {
        return el >= 1024;
      })[0]] || last,
      md: images[keys.filter(function (el) {
        return el >= 1196;
      })[0]] || last,
      lg: images[keys.filter(function (el) {
        return el >= 1680;
      })[0]] || last,
      xl: last
    };
  }

  return fluid && fluid.src;
}

exports.createLsgSrcsetFromFluidImage = createLsgSrcsetFromFluidImage; // changed this functionality => needs to replace existing function in @lws/react-components and the components need to be tweaked

exports.LsgPicture = function (_a) {
  var data = _a.data,
      asBackgroundImage = _a.asBackgroundImage,
      asInline = _a.asInline,
      backgroundFocalPoint = _a.backgroundFocalPoint,
      imgWidth = _a.imgWidth,
      imgHeight = _a.imgHeight,
      maxWidth = _a.maxWidth,
      style = _a.style,
      className = _a.className,
      id = _a.id,
      children = _a.children,
      alt = _a.alt;
  var fluid = data.fluid();
  return react_1["default"].createElement(components_1.Picture, {
    asBackgroundImage: asBackgroundImage,
    asInline: asInline,
    backgroundFocalPoint: backgroundFocalPoint,
    imgWidth: imgWidth,
    imgHeight: imgHeight,
    maxWidth: maxWidth,
    style: style,
    src: createLsgSrcsetFromFluidImage(fluid) || '',
    className: className,
    id: id,
    alt: data.title() || alt
  }, children);
};